import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { BriefDocument } from "@/components/BriefDocument";
import { ShareDialog } from "@/components/ShareDialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Printer, ArrowLeft } from "lucide-react";

export default function Export() {
  const { id } = useParams();
  const nav = useNavigate();
  const { t } = useTranslation();
  const [brief, setBrief] = useState(null);

  useEffect(() => {
    api
      .get(`/decisions/${id}/export`)
      .then((r) => setBrief(r.data))
      .catch(() => {
        toast.error(t("export.nothing"));
        nav(`/decision/${id}`);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, nav]);

  if (!brief) return null;

  return (
    <div className="min-h-screen bg-secondary/40 py-10">
      <div className="mx-auto max-w-3xl px-6">
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Button variant="ghost" size="sm" onClick={() => nav(`/decision/${id}`)}>
            <ArrowLeft className="mr-1.5 h-4 w-4" /> {t("common.back")}
          </Button>
          <div className="flex items-center gap-2">
            <ShareDialog decisionId={id} title={brief.title} />
            <Button
              className="bg-primary text-primary-foreground hover:opacity-90"
              onClick={() => window.print()}
              data-testid="print-brief-btn"
            >
              <Printer className="mr-1.5 h-4 w-4" /> {t("export.print")}
            </Button>
          </div>
        </div>

        <BriefDocument brief={brief} />
      </div>
    </div>
  );
}
